import React, { Suspense, lazy } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Navbar from "./Components/Shared/Navbar";
import Footer from "./Components/Shared/Footer";
import Loader from "./Components/Common/Loader";
import RequireAuth from "./Auth/RequireAuth";
import RequireAdmin from "./Components/Shared/RequireAdmin";

const Home = lazy(() => import("./Pages/Home"));
const AllProducts = lazy(() => import("./Pages/AllProducts"));
const ProductDetails = lazy(() => import("./Pages/ProductDetails"));
const ViewCart = lazy(() => import("./Pages/ViewCart"));
const ThankYou = lazy(() => import("./Pages/ThankYou"));
const TrackOrder = lazy(() => import("./Pages/TrackOrder"));
const Gallery = lazy(() => import("./Pages/Gallery"));
const Reviews = lazy(() => import("./Pages/Reviews"));
const Tutorials = lazy(() => import("./Pages/Tutorials"));
const Login = lazy(() => import("./Pages/Login"));
const Signup = lazy(() => import("./Pages/Signup"));
const ForgetPassword = lazy(() => import("./Pages/ForgetPassword"));
const Borka = lazy(() => import("./Components/Home/Borka"));
const Hijab = lazy(() => import("./Components/Home/Hijab"));
const Dashboard = lazy(() => import("./Pages/Dashboard/Dashboard"));
const DashboardLayout = lazy(() => import("./Components/Layouts/DashboadLayout"));
const AllUsers = lazy(() => import("./Pages/Dashboard/AllUsers"));
const AddProduct = lazy(() => import("./Pages/Dashboard/AddProduct"));
const ManageProducts = lazy(() => import("./Pages/Dashboard/ManageProducts"));
const AddGalleryImages = lazy(() => import("./Pages/Dashboard/AddGalleryImages"));
const AddBanner = lazy(() => import("./Pages/Dashboard/AddBanner"));
const AddVideo = lazy(() => import("./Pages/Dashboard/AddVideo"));
const AllOrders = lazy(() => import("./Pages/Dashboard/AllOrders"));
const AllReviews = lazy(() => import("./Pages/Dashboard/AllReviews"));
const MyProfile = lazy(() => import("./Pages/Dashboard/MyProfile"));
const EditModal = lazy(() => import("./Components/Dashboard/EditModal"));
const StorePurchase = lazy(() => import("./Pages/Dashboard/StorePurchase"));
const NotFound = lazy(() => import("./Components/Common/NotFound"));

function AppChrome() {
  const location = useLocation();
  const isDashboard = location.pathname.startsWith("/dashboard");
  const hideShell = isDashboard || location.pathname === "/login" || location.pathname === "/signup" || location.pathname === "/forget-password";

  return (
    <div className="min-h-screen">
      <Helmet>
        <title>ইসলামিক পোশাক | প্রিমিয়াম মডেস্ট ফ্যাশন</title>
        <meta
          name="description"
          content="গেস্ট চেকআউট, দ্রুত ডেলিভারি, এবং প্রিমিয়াম স্টোরফ্রন্ট অভিজ্ঞতা সহ আধুনিক মডেস্ট ফ্যাশন শপ।"
        />
      </Helmet>
      <Suspense fallback={<Loader />}>
        {!hideShell ? <Navbar /> : null}
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/all-products" element={<AllProducts />} />
            <Route path="/productDetails/:id" element={<ProductDetails />} />
            <Route path="/viewCart" element={<ViewCart />} />
            <Route path="/thankyou" element={<ThankYou />} />
            <Route path="/track-order" element={<TrackOrder />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/tutorials" element={<Tutorials />} />
            <Route path="/borka" element={<Borka />} />
            <Route path="/hijab" element={<Hijab />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forget-password" element={<ForgetPassword />} />
            <Route path="*" element={<NotFound />} />

            <Route
              path="dashboard"
              element={
                <RequireAuth>
                  <DashboardLayout />
                </RequireAuth>
              }
            >
              <Route index element={<Dashboard />} />
              <Route
                path="all-users"
                element={
                  <RequireAdmin>
                    <AllUsers />
                  </RequireAdmin>
                }
              />
              <Route
                path="add-product"
                element={
                  <RequireAdmin>
                    <AddProduct />
                  </RequireAdmin>
                }
              />
              <Route
                path="manage-products"
                element={
                  <RequireAdmin>
                    <ManageProducts />
                  </RequireAdmin>
                }
              />
              <Route
                path="add-gallery-image"
                element={
                  <RequireAdmin>
                    <AddGalleryImages />
                  </RequireAdmin>
                }
              />
              <Route
                path="add-video"
                element={
                  <RequireAdmin>
                    <AddVideo />
                  </RequireAdmin>
                }
              />
              <Route
                path="add-banner"
                element={
                  <RequireAdmin>
                    <AddBanner />
                  </RequireAdmin>
                }
              />
              <Route
                path="all-orders"
                element={
                  <RequireAdmin>
                    <AllOrders />
                  </RequireAdmin>
                }
              />
              <Route
                path="all-reviews"
                element={
                  <RequireAdmin>
                    <AllReviews />
                  </RequireAdmin>
                }
              />
              <Route path="my-profile" element={<MyProfile />} />
              <Route path="edit-product/:id" element={<EditModal />} />
              <Route
                path="store-purchase"
                element={
                  <RequireAdmin>
                    <StorePurchase />
                  </RequireAdmin>
                }
              />
            </Route>
          </Routes>
        </main>
        {!hideShell ? <Footer /> : null}
      </Suspense>
    </div>
  );
}

export default AppChrome;
